export function toDateKey(value) {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}

export function normalizeDayLessons(dayData) {
  if (Array.isArray(dayData)) {
    return dayData
      .map((item, idx) => ({ key: idx + 1, value: item }))
      .filter((item) => item.value && item.value.lesson);
  }

  if (!dayData || typeof dayData !== "object") return [];

  return Object.entries(dayData)
    .sort((a, b) => Number(a[0]) - Number(b[0]))
    .map(([key, value]) => ({ key: Number(key || 0), value }))
    .filter((item) => item.value && item.value.lesson);
}

export function getPauseTime(end, start) {
  if (!start || !end) return 0;
  const startParts = String(start).trim().split(":");
  const endParts = String(end).trim().split(":");
  if (startParts.length < 2 || endParts.length < 2) return 0;

  const startH = Number(startParts[0] || 0);
  const startM = Number(startParts[1] || 0);
  const endH = Number(endParts[0] || 0);
  const endM = Number(endParts[1] || 0);
  if (
    !Number.isFinite(startH) ||
    !Number.isFinite(startM) ||
    !Number.isFinite(endH) ||
    !Number.isFinite(endM)
  ) {
    return 0;
  }
  const startTotal = startH * 60 + startM;
  const endTotal = endH * 60 + endM;
  const diff = startTotal - endTotal;
  if (diff <= 0 || diff > 45) return 0;
  return diff;
}

export function getColorClassByMark(mark) {
  if (!mark) return "";
  const mId = Number(mark?.m_id || mark?._data?.m_id || 0);
  if (mId === 104) return "empty";

  let colorMark = mark?.mark_value ?? mark?._data?.mark_value ?? mark?.value;
  if (colorMark === "Н" || colorMark === "Рќ" || colorMark === "H") return "grey";

  const lessonView = Number(
    mark?.lplan?.lesson_view ||
      mark?._lplan?._data?.lesson_view ||
      mark?._lplan?.lesson_view ||
      0
  );
  if ((lessonView === 21 || lessonView === 22 || lessonView === 33) && mId !== 105) {
    const ball = Number(mark.ball || mark?._data?.ball || 0);
    const soBall = Number(mark.so_ball || mark?.lplan?.so_ball || mark?._lplan?._data?.so_ball || 0);
    if (soBall > 0) colorMark = Math.round((ball / soBall) * 10);
  }
  if (mId === 105 && !Number.isFinite(Number(colorMark)) && Number.isFinite(Number(mark?.ball))) {
    colorMark = mark.ball;
  }

  const value = Number(colorMark);
  if (!Number.isFinite(value)) return "";
  if (value >= 9) return "green";
  if (value >= 7) return "yellow";
  if (value >= 4) return "orange";
  if (value >= 0) return "red";
  return "";
}

export function resolveSubjectByLang(subject, lang = "ru") {
  if (!subject) return "";
  if (typeof subject === "string") return subject;
  return (
    subject?.[lang] ||
    subject?.[lang === "kz" ? "kk" : "ru"] ||
    subject?.ru ||
    subject?.kz ||
    subject?.kk ||
    subject?.name ||
    ""
  );
}

export function rawRow(item) {
  if (item && typeof item === "object" && item._data) return item._data;
  return item || {};
}

export function normalizeDateKey(value) {
  if (!value) return "";
  if (typeof value === "number") return toDateKey(value * (value > 1e12 ? 1 : 1000));
  return toDateKey(value);
}
